module.exports = __webpack_public_path__ + "img/chinesecompany41.74cec43c.png";